import React from 'react'
import { Stack } from '@mui/material'

import Video from './Video';



const Videos = ({data}) => {

  
  return (
   <>
     <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={2} backgroundColor="white">
   {
     data?.map((e,idx)=>(
       <Video e={e} idx={idx} key={idx}/>
     ))
   
}
     </Stack>
</>
  )
}

export default Videos